// extracted by mini-css-extract-plugin
export var beigeBg = "styles-module--beigeBg--33b35";
export var button = "styles-module--button--9491e";
export var gridContainer = "styles-module--gridContainer--62abd";
export var innerContainer = "styles-module--innerContainer--4c31d";
export var innerContainerSm = "styles-module--innerContainerSm--b637e";
export var scrollContainer = "styles-module--scrollContainer--11523";
export var scrollContainerSm = "styles-module--scrollContainerSm--52d7d";